import type { IconSvgObject } from './types';

const CircleArrowUp03Icon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5152 12.5036C13.9844 11.9728 12.6908 9.99529 11.9455 10.0058C11.2077 10.0865 10.0313 12.0088 9.51149 12.5138M12.0354 17.0043L12.0211 10.0112M8 7.00901L15.9921 6.99268", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowUp03Icon;
